import { PropsWithChildren, useCallback, useEffect, useState } from 'react';
import { Icon, IconTypes } from '@tencentcloud/chat-uikit-react';
import { useTUILiveContext } from '../';
import constant, { STORAGE_NAME } from '../../../../constants';
import AppLoading from '../../../AppLoading';

interface ativeClickReturn {
  value?: boolean;
  suffixValue?: boolean;
}

interface useLiveAtiveBasicParams {
  className?: string;
  icon?: IconTypes;
  activeIcon?: IconTypes;
  iconWidth?: number;
  iconHeight?: number;
  name?: string;
  key?: string;
  value?: boolean;
  onClick?: () => Promise<ativeClickReturn>;
}

export interface useLiveAtiveElementsParams extends useLiveAtiveBasicParams {
  suffix?: useLiveAtiveBasicParams;
}

export function useLiveAtiveElements<T extends useLiveAtiveElementsParams>(
  props: PropsWithChildren<T>
) {
  const {
    name,
    key = '',
    icon,
    activeIcon,
    value: propsValue,
    className,
    suffix,
    iconWidth,
    iconHeight,
  } = props;

  const { increaseGroupCounter, decreaseGroupCounter, callback } =
    useTUILiveContext('TUILiveHeader');

  const [value, setValue] = useState(false);
  const [suffixValue, setSuffixValue] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  //  Stream Like & Follow
  const searchParams = new URLSearchParams(document.location.search);

  const hadnleGroupCounter = useCallback(
    async (data: boolean) => {
      var currentPost = JSON.parse(
        localStorage.getItem(
          STORAGE_NAME.CURRENT_POST + searchParams.get('roomId')
        ) ?? '{}'
      );
      var postId = searchParams.get('roomId') ?? '';
      var userId = searchParams.get('userId') ?? '';
      var followingID = currentPost?.post_data?.post_author;
      var url = '';
      var formdata = new FormData();
      var apiHeaders = new Headers();
      apiHeaders.append('Access-Control-Allow-Origin', '*');
      apiHeaders.append('Access-Control-Allow-Credentials', 'true');
      formdata.append('user_id', userId);

      if (key == 'LiveHeart') {
        url = '/wp-json/stream/like';
        formdata.append('post_id', postId);
      }

      if (key == 'LiveFollow') {
        url = '/wp-json/stream/follow';
        formdata.append('following_id', followingID);
      }

      url &&
        fetch(constant.apiUrl + url, {
          method: 'POST',
          body: formdata,
        })
          .then((response) => response.text())
          .then((result) => {
            setIsLoading(false);
          })
          .catch((error) => {
            console.log('error', error);
            setIsLoading(false);
            return;
          });

      if (data && increaseGroupCounter) {
        await increaseGroupCounter({
          key,
          value: 1,
        });
      }
      if (!data && decreaseGroupCounter) {
        await decreaseGroupCounter({
          key,
          value: 1,
        });
      }
      setValue(!value);
      callback && callback(key);
    },
    [increaseGroupCounter, decreaseGroupCounter, callback, key, value]
  );

  const handleClick = async () => {
    if (!isLoading) {
      if (searchParams.get('role') == constant.roleLiver) {
        return;
      }
      setIsLoading(true);
      await hadnleGroupCounter(!value);
      setSuffixValue(false);
    }
  };

  const handleSuffixClick = async () => {
    if (value) {
      await hadnleGroupCounter(suffixValue);
    }
    setSuffixValue(!suffixValue);
    setValue(false);
  };

  useEffect(() => {
    if (propsValue) {
      setValue(propsValue);
    }
  }, [propsValue]);

  useEffect(() => {
    if (suffix?.value) {
      setSuffixValue(suffix?.value);
    }
  }, [suffix?.value]);

  return (
    <>
      <AppLoading loading={isLoading} />
      <li
        className={`tui-live-item opate-item ${
          key == 'LiveHeart' ? 'button-gap-unset' : ''
        }`}
        key={name}
        onClick={handleClick}
      >
        <div className={`opate-box ${className}`} role='menuitem' tabIndex={0}>
          <Icon
            type={value ? activeIcon : icon}
            width={iconWidth || 15}
            height={iconHeight || 15}
          />
          <span className='list-item-text'>{name}</span>
        </div>
        {/* {
        suffix && (
        <div role='menuitem' tabIndex={0} className='opate-item-suffix line opate-box' onClick={handleSuffixClick}>
          <Icon
            type={suffixValue ? suffix.activeIcon : suffix.icon}
            width={iconWidth || 15}
            height={iconHeight || 15}
          />
        </div>
        )
      } */}
      </li>
    </>
  );
}
